export default "__VITE_ASSET__c8WPNKuQ__"